import type { CSSObjectWithLabel, Theme } from "react-select";

interface StyleOptions {
  menuWidth?: string | number;
}

export const buildStyles = ({ menuWidth }: StyleOptions) => {
  const menuProperties: CSSObjectWithLabel = {
    zIndex: 9999,
    margin: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  };

  if (menuWidth) {
    menuProperties.width = menuWidth;
  }

  return {
    menu: (provided: CSSObjectWithLabel) => Object.assign({}, provided, menuProperties),
  };
};

export const buildTheme = (theme: Theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: theme.colors.primary,
    primary25: theme.colors.primary25,
    primary50: theme.colors.primary50,
    primary75: theme.colors.primary75,
    neutral5: "#e1e1e1",
  },
});
